module.exports = __webpack_public_path__ + "static/media/theNakama.4c008dda.png";